<template>
	<pui-modal-dialog
		v-if="show"
		:cancelText="$t('form.cancel')"
		:okText="$t('pui9.accept')"
		:disableOk="disableOk"
		:titleText="titleText"
		:messageText="messageText"
		dialogName="resetPasswordUser"
		ref="resetPasswordUser"
	>
		<template #message>
			<div autocomplete="off" class="pa-2">
				<v-row dense>
					<v-col cols="12">
						<pui-text-field
							ref="newPasswordField"
							toplabel
							:label="$t('userappresetpassword.newpassword')"
							v-model="newPassword"
							type="password"
							required
							realtime
							autocomplete="new-password"
						/>
					</v-col>

					<v-col cols="12">
						<pui-text-field
							ref="confirmPasswordField"
							toplabel
							:label="$t('userappresetpassword.confirmpassword')"
							v-model="confirmPassword"
							type="password"
							required
							realtime
							autocomplete="new-password"
						/>
						<!-- Mensaje simple de ayuda si no coinciden -->
						<div v-if="confirmPassword && !passwordsMatch" class="error--text text-caption mt-1">
							{{ $t('userappresetpassword.nomatch') || 'Las contraseñas no coinciden' }}
						</div>
					</v-col>
				</v-row>
			</div>
		</template>
	</pui-modal-dialog>
</template>

<script>
export default {
	props: {
		modelName: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			show: false,
			disableOk: true,
			titleText: this.$t('userappresetpassword.title'),
			messageText: '',
			usr: null,
			newPassword: '',
			confirmPassword: ''
		};
	},
	computed: {
		passwordsMatch() {
			return this.newPassword && this.confirmPassword && this.newPassword === this.confirmPassword;
		}
	},
	watch: {
		newPassword() {
			this.updateDisableOk();
		},
		confirmPassword() {
			this.updateDisableOk();
		}
	},
	mounted() {
		this.subscribeToModalDialogEvent();
	},
	methods: {
		updateDisableOk() {
			// Deshabilitamos el OK si falta alguna o no coinciden
			this.disableOk =
				!this.newPassword ||
				this.newPassword.trim() === '' ||
				!this.confirmPassword ||
				this.confirmPassword.trim() === '' ||
				!this.passwordsMatch;
		},

		resetState(usr) {
			this.usr = usr || null;
			this.newPassword = '';
			this.confirmPassword = '';
			this.disableOk = true;
		},

		subscribeToModalDialogEvent() {
			const self = this;

			// OK del modal
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-ok', () => {
				// Defensa extra: si no coinciden, no llamamos al backend
				if (!this.passwordsMatch) {
					this.$puiNotify.error(
						this.$t('userappresetpassword.nomatch') || 'Las contraseñas no coinciden'
					);
					this.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
					return;
				}

				const thisModel = this.$store.getters.getModelByName(this.modelName);
				if (!thisModel) {
					self.show = false;
					this.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
					return;
				}

				const url = thisModel.url.setPassword;

				// Ya no enviamos oldPassword, solo la nueva
				const params = {
					usr: this.usr,
					newPassword: this.newPassword
					// si en backend esperan otro nombre, cámbialo aquí
					// password: this.newPassword
				};

				this.$puiRequests.getRequest(
					url,
					params,
					// success
					() => {
						self.show = false;
						this.$puiNotify.success(this.$puiI18n.t('puiaction.notifySuccess'));
						this.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
					},
					// error
					error => {
						let message = null;

						if (error && error.response && error.response.data) {
							message = error.response.data.message;
							if (error.response.data.internalCode === 202) {
								const t = this.$t('userappresetpassword.202');
								if (t) {
									message = t;
								}
							}
						}

						if (!message) {
							message = this.$t('general.error') || 'Error al cambiar la contraseña';
						}

						this.$puiNotify.error(message);
						// importante: terminar la acción aunque haya error
						this.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
					}
				);
			});

			// Cancel del modal
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-cancel', () => {
				self.show = false;
				this.$puiEvents.$emit('onPui-action-running-ended-' + self.modelName);
			});

			// Mostrar modal (llamado desde la action)
			this.$puiEvents.$on('pui-modalDialog-resetPasswordUser-show', usr => {
				this.resetState(usr);
				this.show = true;

				// pequeño truco para limpiar posibles autofills del navegador
				this.$nextTick(() => {
					const newInput =
						this.$refs.newPasswordField &&
						this.$refs.newPasswordField.$el &&
						this.$refs.newPasswordField.$el.querySelector('input');
					if (newInput) {
						newInput.value = '';
					}
					const confirmInput =
						this.$refs.confirmPasswordField &&
						this.$refs.confirmPasswordField.$el &&
						this.$refs.confirmPasswordField.$el.querySelector('input');
					if (confirmInput) {
						confirmInput.value = '';
					}
				});
			});
		}
	},
	destroyed() {
		this.$puiEvents.$off('pui-modalDialog-resetPasswordUser-ok');
		this.$puiEvents.$off('pui-modalDialog-resetPasswordUser-cancel');
		this.$puiEvents.$off('pui-modalDialog-resetPasswordUser-show');
	}
};
</script>
